class TermsModal extends ModalDialog {
  constructor() {
    super();
    this.querySelector('[id^="ModalConfirm-"]').addEventListener('click', this.confirm.bind(this, false));
  }

  confirm() {
    const cateringTerms = this.querySelector('#product-catering-terms');

    if(!cateringTerms || cateringTerms?.checked) {
      this.hide();
    }
  }
}

customElements.define('terms-modal', TermsModal);
